import { schema } from "normalizr";

const LeavePolicyRuleSchema = new schema.Entity("leavePolicyRules");
const LeavePolicyRuleArraySchema = new schema.Array(LeavePolicyRuleSchema);

export { 
  LeavePolicyRuleSchema,
  LeavePolicyRuleArraySchema
};